import { render, staticRenderFns } from "./ScheduleHeading.vue?vue&type=template&id=66ddff26&scoped=true&"
import script from "./ScheduleHeading.vue?vue&type=script&lang=js&"
export * from "./ScheduleHeading.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleHeading.vue?vue&type=style&index=0&id=66ddff26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ddff26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
